module.exports = __webpack_public_path__ + "img/IMG_1645_Foamcore_MockedUp.39f4a3fa.jpg";